import { ContentIconLinkList } from './content/icon-link-list';

/**
 * Model definition for footer
 */
export interface LegalFooter {
  __contentType: 'legal-footer';
  id: string;
  linkList?: ContentIconLinkList;
  articleText?: string;
}

export function isLegalFooter(obj: { __contentType?: string; __component?: string }): obj is LegalFooter {
  // TODO: Remove Bridge for legal legal footer in SIP
  return obj.__contentType === 'legal-footer' || obj.__component === 'content.legal-footer';
}
